import AppValidationError from '@/error/appValidationError'

export enum PostContentConstraints {
  MIN_LENGTH = 0,
  MAX_LENGTH = 3600,
  MAX_EMOJIS = 10,
}

export default function validatePost(post: PostUpdateInterface) {
  const constraints: Map<string, Array<string>> = new Map()

  if (post.content === '') {
    constraints.set('content', ['error.fieldLengthMin'])
  }
  if (post.content.length > PostContentConstraints.MAX_LENGTH) {
    constraints.set('content', ['error.fieldLengthMax'])
  }
  const object = post.content.match(/\p{Emoji_Presentation}/gu)
  if (object !== null && object.length > PostContentConstraints.MAX_EMOJIS) {
    constraints.set('content', ['error.fieldMaxEmojis'])
  }

  if (constraints.size > 0) {
    throw new AppValidationError(constraints)
  }
}
